import React from 'react'
//import bam from "../img/logos_bancos/Bac.png" //../../../../public/img/logos_bancos/Bam.jpg
import { Bac, Bam, Banrural, Interbanco } from './iconos_bancos'

const sedes = [
    {IdSede:1, Nombre:"10", icono: Bac}, 
    //{IdSede:2, Nombre:"10", icono: Bam}, 
    {IdSede:3, Nombre:"10", icono: Banrural}, 
    {IdSede:4, Nombre:"10", icono: Interbanco}, 
]

const sede="10"


const CirculosBancos = () => {

    const handleSede = () => {

    }

  return (
    <div className='flex m-auto lg:flex-row flex-col xl:justify-center elementFadeIn'>
      <div
        className={
          "w-full lg:w-1/2 flex flex-row justify-start my-2"
        }
      >
        {sedes.map((element) => (
          <>
            <div className="flex flex-row container">
              <div
                className={
                  sede === element["IdSede"]
                    ? "/element grid m-1 w-20 h-20 rounded-full /ring-azulBrillanteMira  /ring-1 /bg-azulBrillanteMira hover:shadow-md hover:shadow-white transition duration-150 ease hover:ease"
                    : "/element grid m-1 w-20 h-20 rounded-full /ring-azulBrillanteMira  /ring-1 /hover:bg-azulBrillanteMira hover:shadow-md hover:shadow-white transition duration-150 ease hover:ease"
                }
                key={element["IdSede"]}
                onClick={() =>
                  handleSede(element["IdSede"], element.Nombre)
                }
                // onMouseEnter={() => setSedeNombre(element.Nombre)}
               >
                <img src={element.icono} alt="" className=" rounded-full h-full"/>
              </div>
              
            </div>
          </>
        ))}  
      </div>
        <div className={"flex lg:w-1/2 w-full flex-row justify-end my-auto"}>
          <select className={"rounded-md /|m-auto"}>
            <option value="">--- Seleccione una cuenta ---</option>
          </select>
        </div>
    </div>
  )
}

export default CirculosBancos